var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar navbar-light bg-white"},[(_vm.$route.params.tenant)?_c('div',{staticClass:"d-flex justify-content-center navbar-brand"},[_c('img',{attrs:{"src":require('assets/images/logos/' + _vm.$route.params.tenant + '.svg'),"alt":"Logo"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }